import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import heroImage from '../assets/engagementPics/DSC_3017.JPEG';

const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 4rem 0;
`;

const WelcomeText = styled.h2`
  font-family: 'Lora', serif;
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 1.5rem;
  font-weight: 500;
`;

const Message = styled.p`
  font-family: 'EB Garamond', serif;
  font-size: 1.3rem;
  color: #666;
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
`;

const HeroImageContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 4rem auto;
  position: relative;
  aspect-ratio: 3/2;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
`;

const ImagePlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  display: ${props => props.isHidden ? 'none' : 'block'};
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  opacity: ${props => props.isLoaded ? 1 : 0};
  transition: opacity 0.5s ease-in-out;
`;

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const Home = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Preload the hero image
    const img = new Image();
    img.src = heroImage;
    img.onload = () => setImageLoaded(true);
  }, []);

  return (
    <PageContainer className="fade-in">
      <HeroSection>
        <WelcomeText>Welcome to Our Wedding Celebration</WelcomeText>
        <Message>
          We are overjoyed to share our special day with our beloved family and friends.
          As we begin this beautiful journey together, we invite you to join us in
          celebrating our love and commitment to each other.
        </Message>
      </HeroSection>
      
      <HeroImageContainer>
        <ImagePlaceholder isHidden={imageLoaded} />
        <StyledImage
          src={heroImage}
          alt="Hana and David"
          isLoaded={imageLoaded}
          width={1000}
          height={667}
        />
      </HeroImageContainer>
      
      <HeroSection>
      </HeroSection>
    </PageContainer>
  );
};

export default Home;